import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { Transaction, Transfer } from '@kr/models';

import { TransferApiService } from '../api/transfer-api.service';
import { PayOutRes } from '../models/pay-out.response';

@Injectable({ providedIn: 'root' })
export class TransferApiMockService extends TransferApiService {
  override getEstimatesTransferInternal(_body: Transfer, _orgId: number): Observable<Transaction> {
    const mockResponse: Transaction = {
      network_fee_coin_id: '',
      coin: undefined,
      coinId: '',
      comment: '',
      created: 0,
      feeTotal: '',
      feeTotalCoinId: '',
      feeTotalNative: '',
      fromWalletType: '',
      id: 0,
      internalOrgId: 0,
      statusOriginal: undefined,
      totalAmount: '',
      trTypeString: undefined,
      tx: '',
      ourEstimatedFee: 1,
      address: 'address',
      addressOut: '',
      fromWallet: '',
      toWallet: '',
      amount: '',
      network_fee_amount: '',
      process_fee_amount: '',
      warnings: "Can't get a status from provider",
    };
    return of(mockResponse);
  }

  override getEstimatesTransferExternal(_body: Transfer, _orgId: number): Observable<Transaction> {
    const mockResponse: Transaction = {
      network_fee_coin_id: '',
      riskScore: '',
      riskScoreError: '',
      riskScorePassed: false,
      scanUrl: '',
      coin: undefined,
      coinId: '',
      comment: '',
      created: 0,
      feeTotal: '',
      feeTotalCoinId: '',
      feeTotalNative: '',
      fromWalletType: '',
      id: 0,
      internalOrgId: 0,
      statusOriginal: undefined,
      totalAmount: '',
      trTypeString: undefined,
      tx: '',
      ourEstimatedFee: 1,
      address: 'address',
      addressOut: '',
      fromWallet: '',
      toWallet: '',
      amount: '',
      network_fee_amount: '',
      process_fee_amount: '',
      warnings: "Can't get a status from provider",
    };
    return of(mockResponse);
  }

  override executeTransferInternal(_body: Transfer, _orgId: number): Observable<PayOutRes> {
    const mockResponse: PayOutRes = {
      transactionId: 0,
      tx: '',
    };
    return of(mockResponse);
  }

  override executeTransferExternal(_body: Transfer, _orgId: number): Observable<PayOutRes> {
    const mockResponse: PayOutRes = {
      transactionId: 0,
      tx: '',
    };
    return of(mockResponse);
  }
}
